"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeGen = void 0;
var redux_1 = require("redux");
var redux_logger_1 = require("redux-logger");
var connected_react_router_1 = require("connected-react-router");
function storeGen(reducer, history, preloadedState) {
    if (preloadedState === void 0) { preloadedState = {}; }
    var middlewares = [(0, connected_react_router_1.routerMiddleware)(history)];
    if (process.env.NODE_ENV !== "production") {
        middlewares.push((0, redux_logger_1.createLogger)());
    }
    return (0, redux_1.createStore)(reducer, preloadedState, (0, redux_1.compose)(redux_1.applyMiddleware.apply(void 0, __spreadArray([], __read(middlewares), false))));
}
exports.storeGen = storeGen;
